module.exports = __webpack_public_path__ + "static/media/STELLA.9cb475dd.png";